module.exports = __webpack_public_path__ + "img/pigc1.a040e59b.png";